import { render, staticRenderFns } from "./UserClientInfo.vue?vue&type=template&id=25b5b9b5&"
import script from "./UserClientInfo.vue?vue&type=script&lang=js&"
export * from "./UserClientInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports